import { render, staticRenderFns } from "./Cl4Face.vue?vue&type=template&id=85664316"
import script from "./Cl4Face.vue?vue&type=script&lang=js"
export * from "./Cl4Face.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports